import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const VietnamPage = () => {
  return <DestinationTemplate destinationId="vietnam" />;
};

export default VietnamPage;
